module.exports = __webpack_public_path__ + "static/media/shawnkim.f60b9605.jpeg";